export function isProduction() {
    return process.env.REACT_APP_APPLICATION_UID === "admin";
}
